// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_exceptions from "rescript/lib/es6/caml_exceptions.js";
import * as Error$LiteracyplanetClientErrors from "@literacyplanet/client-errors/src/Error.res.mjs";
import * as Option2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Option2.res.mjs";
import * as Result2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Result2.res.mjs";
import * as MapResult$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/MapResult.res.mjs";
import * as Md5$LiteracyplanetClientLibsActivity from "@literacyplanet/client-libs-activity/src/Md5.res.mjs";
import * as HasuraTypes$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/HasuraTypes.res.mjs";
import * as Flipper$LiteracyplanetClientSxActivity from "./Flipper.res.mjs";
import * as FlipperStore$LiteracyplanetClientSxActivity from "./FlipperStore.res.mjs";
import * as AvatarQuery$LiteracyplanetClientLibsActivity from "@literacyplanet/client-libs-activity/src/AvatarQuery.res.mjs";
import * as FlipperTypes$LiteracyplanetClientLibsActivity from "@literacyplanet/client-libs-activity/src/FlipperTypes.res.mjs";
import * as FlipperAsyncHook$LiteracyplanetClientSxActivity from "./FlipperAsyncHook.res.mjs";
import * as BehaviourTestActivityPage$LiteracyplanetTupperware from "@literacyplanet/tupperware/src/tupperware/v2/BehaviourTestActivityPage.res.mjs";
import * as Flipper_GameContent$LiteracyplanetClientSxActivity from "./Flipper_GameContent.res.mjs";
import * as FlipperVideoDispatch$LiteracyplanetClientSxActivity from "./FlipperVideoDispatch.res.mjs";
import * as CobraPersistedState$LiteracyplanetClientLibsActivity from "@literacyplanet/client-libs-activity/src/CobraPersistedState.res.mjs";
import * as FlipperCobraCallbacks$LiteracyplanetClientSxActivity from "./FlipperCobraCallbacks.res.mjs";
import * as V2ExerciseStateStoreContext$LiteracyplanetTupperware from "@literacyplanet/tupperware/src/tupperware/v2/V2ExerciseStateStoreContext.res.mjs";
import * as AcademyActivityQuery$LiteracyplanetClientLibsActivity from "@literacyplanet/client-libs-activity/src/AcademyActivityQuery.res.mjs";
import * as CobraQuestionResponse$LiteracyplanetClientLibsActivity from "@literacyplanet/client-libs-activity/src/CobraQuestionResponse.res.mjs";
import * as DeleteStudentQuestionResponses$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/DeleteStudentQuestionResponses.res.mjs";
import * as StudentResponseMutation$LiteracyplanetClientLibsActivity from "@literacyplanet/client-libs-activity/src/StudentResponseMutation.res.mjs";
import * as AcademyActivityMutations$LiteracyplanetClientLibsActivity from "@literacyplanet/client-libs-activity/src/AcademyActivityMutations.res.mjs";
import * as FlipperTupperwareCallbacks$LiteracyplanetClientSxActivity from "./FlipperTupperwareCallbacks.res.mjs";
import * as FlipperCobraResultsCallbacks$LiteracyplanetClientSxActivity from "./FlipperCobraResultsCallbacks.res.mjs";

var FlipperAcademyCantFindContent = /* @__PURE__ */Caml_exceptions.create("FlipperAcademyLauncher-LiteracyplanetClientSxActivity.FlipperAcademyCantFindContent");

var FlipperAcademyCantFindGameId = /* @__PURE__ */Caml_exceptions.create("FlipperAcademyLauncher-LiteracyplanetClientSxActivity.FlipperAcademyCantFindGameId");

var FlipperAcademyCantFindActivity = /* @__PURE__ */Caml_exceptions.create("FlipperAcademyLauncher-LiteracyplanetClientSxActivity.FlipperAcademyCantFindActivity");

function parseActivities(res) {
  return Belt_Array.get(res.academy_query_activity, 0);
}

function getActivity(res) {
  return Result2$LiteracyplanetClientFlags.Opt.toResult(Belt_Option.map(Belt_Array.get(res.academy_query_activity, 0), (function (a) {
                    return a.content;
                  })), {
              RE_EXN_ID: FlipperAcademyCantFindContent
            });
}

function getGameId(res) {
  return Result2$LiteracyplanetClientFlags.Opt.toResult(Belt_Option.map(Belt_Array.get(res.academy_query_activity, 0), (function (a) {
                    return a.kind;
                  })), {
              RE_EXN_ID: FlipperAcademyCantFindGameId
            });
}

function findActivityData(res) {
  return Result2$LiteracyplanetClientFlags.Opt.toResult(Belt_Array.get(res.academy_query_activity, 0), {
              RE_EXN_ID: FlipperAcademyCantFindActivity
            });
}

function FlipperAcademyLauncher$TupperwareCallbacks(props) {
  var activity = props.activity;
  var updateStateMutation = props.updateStateMutation;
  var activityCompletedMutation = props.activityCompletedMutation;
  var questionFailedMutation = props.questionFailedMutation;
  var questionPasseMutation = props.questionPasseMutation;
  var match = FlipperStore$LiteracyplanetClientSxActivity.Context.initaliseState(false, activity.numComplete, activity.numCorrect);
  var activityDispachables = FlipperTupperwareCallbacks$LiteracyplanetClientSxActivity.wrapApiWithStoreEvents(FlipperTupperwareCallbacks$LiteracyplanetClientSxActivity.api, match[1], false, (function (param) {
          return activityCompletedMutation();
        }), undefined, undefined, (function (param, param$1) {
          console.log("exit on outside");
        }), (function (param) {
          return questionFailedMutation(param.questionIndex, param.serializedState, undefined, param.responsesCorrect, param.responsesComplete);
        }), (function (param) {
          return questionPasseMutation(param.questionIndex, param.serializedState, undefined, param.responsesCorrect, param.responsesComplete);
        }), (function (questionIndex, serializedState) {
          return updateStateMutation(questionIndex, serializedState);
        }), undefined);
  var resultDispatchables = FlipperCobraResultsCallbacks$LiteracyplanetClientSxActivity.useResultsDispatch();
  return React.createElement(FlipperTupperwareCallbacks$LiteracyplanetClientSxActivity.Provider.make, {
              dispachables: activityDispachables,
              children: React.createElement(FlipperCobraResultsCallbacks$LiteracyplanetClientSxActivity.Provider.make, {
                    dispachables: resultDispatchables,
                    children: React.createElement(V2ExerciseStateStoreContext$LiteracyplanetTupperware.Provider.make, {
                          children: React.createElement(BehaviourTestActivityPage$LiteracyplanetTupperware.make, {
                                persistedState: activity.state,
                                assessment: props.assessment,
                                questionIndex: activity.questionIndex,
                                children: props.children
                              })
                        })
                  })
            });
}

var TupperwareCallbacks = {
  make: FlipperAcademyLauncher$TupperwareCallbacks
};

function use(persistedState, md5, questionPasseMutation, questionFailedMutation, activityCompletedMutation, dispatch) {
  var match = CobraPersistedState$LiteracyplanetClientLibsActivity.use(persistedState, Md5$LiteracyplanetClientLibsActivity.make(md5));
  var collectResponses = match.collectResponses;
  var match$1 = Error$LiteracyplanetClientErrors.useErrorModal();
  var onSetError = match$1.onSetError;
  return FlipperCobraCallbacks$LiteracyplanetClientSxActivity.wrapApiWithStoreEvents(FlipperTypes$LiteracyplanetClientLibsActivity.Cobra.api, dispatch, activityCompletedMutation, undefined, undefined, undefined, undefined, undefined, undefined, (function (err) {
                Curry._1(onSetError, Error$LiteracyplanetClientErrors.JsInterop.makeError(undefined, err));
              }), (function (response) {
                var optState = Curry._1(collectResponses, response);
                CobraQuestionResponse$LiteracyplanetClientLibsActivity.Single.mapQuestionIndexAndAnswers(response, (function (questionIndex, answers) {
                        questionFailedMutation(questionIndex, optState, answers, undefined, undefined);
                      }));
              }), (function (response) {
                var optState = Curry._1(collectResponses, response);
                CobraQuestionResponse$LiteracyplanetClientLibsActivity.Single.mapQuestionIndexAndAnswers(response, (function (questionIndex, answers) {
                        questionPasseMutation(questionIndex, optState, answers, undefined, undefined);
                      }));
              }), undefined, undefined, undefined, undefined);
}

function FlipperAcademyLauncher$CobraCallbacks(props) {
  var activity = props.activity;
  var match = FlipperStore$LiteracyplanetClientSxActivity.Context.initaliseState(false, activity.numComplete, activity.numCorrect);
  var activityDispachables = use(activity.state, activity.contentMd5, props.questionPasseMutation, props.questionFailedMutation, props.activityCompletedMutation, match[1]);
  var resultDispatchables = FlipperCobraResultsCallbacks$LiteracyplanetClientSxActivity.useResultsDispatch();
  return React.createElement(FlipperCobraCallbacks$LiteracyplanetClientSxActivity.Provider.make, {
              dispachables: activityDispachables,
              children: React.createElement(FlipperCobraResultsCallbacks$LiteracyplanetClientSxActivity.Provider.make, {
                    dispachables: resultDispatchables,
                    children: props.children
                  })
            });
}

var CobraCallbacks = {
  use: use,
  make: FlipperAcademyLauncher$CobraCallbacks
};

function FlipperAcademyLauncher$VideoCallbacks(props) {
  var defaultCb = function (param) {
    
  };
  var dispachables_onToolbarExit = props.onExit;
  var dispachables = {
    onInitialized: defaultCb,
    onPlay: defaultCb,
    onPause: defaultCb,
    onScrubStart: defaultCb,
    onScrubEnd: defaultCb,
    onMute: defaultCb,
    onVolumeChange: defaultCb,
    onEnded: defaultCb,
    onTerminated: defaultCb,
    onToolbarExit: dispachables_onToolbarExit
  };
  return React.createElement(FlipperVideoDispatch$LiteracyplanetClientSxActivity.Provider.make, {
              dispachables: dispachables,
              children: props.children
            });
}

var VideoCallbacks = {
  make: FlipperAcademyLauncher$VideoCallbacks
};

function FlipperAcademyLauncher$Mutations(props) {
  var activity = props.activity;
  var insertResponseFullPoints = StudentResponseMutation$LiteracyplanetClientLibsActivity.useFetchFullPoints();
  var insertResponsePartialPoints = StudentResponseMutation$LiteracyplanetClientLibsActivity.useFetchPartialPoints();
  var insertResponse = function (studentActivityAttemptId, answer, responsesCorrect, responsesComplete, points, questionIndex, state, contentMd5) {
    if (responsesCorrect !== undefined && responsesComplete !== undefined) {
      return insertResponsePartialPoints(studentActivityAttemptId, answer, responsesCorrect, responsesComplete, points, questionIndex, state, contentMd5);
    }
    return insertResponseFullPoints(studentActivityAttemptId, answer, points, questionIndex, state, contentMd5);
  };
  var insertAttempt = AcademyActivityMutations$LiteracyplanetClientLibsActivity.useInsertAttempt(activity.academyActivityId);
  var updateActivityCompleted = AcademyActivityMutations$LiteracyplanetClientLibsActivity.useMarkComplete();
  var updateActivityCompleted$1 = function (param) {
    return updateActivityCompleted(activity.academyActivityId);
  };
  var updateState = AcademyActivityMutations$LiteracyplanetClientLibsActivity.useUpdateState();
  var updateState$1 = async function (studentActivityAttemptId, param, state, contentMd5) {
    var match = Option2$LiteracyplanetClientFlags.combine(state, contentMd5);
    if (match !== undefined) {
      updateState(studentActivityAttemptId, match[0], match[1]);
      return ;
    }
    
  };
  var match = FlipperAsyncHook$LiteracyplanetClientSxActivity.use(activity.contentMd5, activity.studentActivityAttemptId, insertAttempt, updateActivityCompleted$1, updateState$1, insertResponse);
  return props.children(match[0], match[1], match[2], match[3]);
}

var Mutations = {
  make: FlipperAcademyLauncher$Mutations
};

function makeNewActivity(content, activity) {
  return {
          academyActivityId: activity.academyActivityId,
          studentActivityAttemptId: activity.studentAttemptId,
          contentMd5: Flipper_GameContent$LiteracyplanetClientSxActivity.getMd5(content),
          attemptMd5: activity.contentMd5,
          state: activity.state,
          assessment: false,
          questionIndex: activity.numComplete,
          numComplete: activity.numComplete,
          numCorrect: activity.numCorrect
        };
}

function FlipperAcademyLauncher$FixVersionConflict(props) {
  var activity = props.activity;
  var content = props.content;
  var match = React.useState(function () {
        return makeNewActivity(content, activity);
      });
  var setAct = match[1];
  var act = match[0];
  var match$1 = React.useState(function () {
        if (Belt_Option.isSome(act.contentMd5) && Belt_Option.isSome(act.attemptMd5) && Caml_obj.notequal(act.contentMd5, act.attemptMd5)) {
          return true;
        } else if (Belt_Option.isSome(act.contentMd5) && Belt_Option.isNone(act.attemptMd5)) {
          if (act.numComplete > 0 || act.questionIndex > 0) {
            return true;
          } else {
            return Belt_Option.mapWithDefault(act.state, false, (function (s) {
                          return s !== "";
                        }));
          }
        } else {
          return false;
        }
      });
  var setConflict = match$1[1];
  var conflict = match$1[0];
  var removeResponses = DeleteStudentQuestionResponses$LiteracyplanetClientFlags.useFetch();
  React.useEffect((function () {
          var run = async function () {
            var studentActivityAttemptId = act.studentActivityAttemptId;
            if (studentActivityAttemptId !== undefined) {
              await removeResponses(studentActivityAttemptId);
              Curry._1(setAct, (function (act) {
                      return {
                              academyActivityId: act.academyActivityId,
                              studentActivityAttemptId: act.studentActivityAttemptId,
                              contentMd5: act.contentMd5,
                              attemptMd5: undefined,
                              state: undefined,
                              assessment: act.assessment,
                              questionIndex: 0,
                              numComplete: 0,
                              numCorrect: 0
                            };
                    }));
              return Curry._1(setConflict, (function (param) {
                            return false;
                          }));
            }
            
          };
          if (conflict) {
            run();
          }
          
        }), [conflict]);
  if (conflict) {
    return React.createElement("div", undefined, "This content has been updated, and there are previous responses to an earlier version.");
  } else {
    return props.children(act);
  }
}

var FixVersionConflict = {
  makeNewActivity: makeNewActivity,
  make: FlipperAcademyLauncher$FixVersionConflict
};

function FlipperAcademyLauncher$Render(props) {
  var query = props.query;
  var content = props.content;
  var game = props.game;
  var title = props.title;
  var onExit = props.onExit;
  return React.createElement(AvatarQuery$LiteracyplanetClientLibsActivity.make, {
              game: game,
              children: React.createElement(MapResult$LiteracyplanetClientFlags.make, {
                    result: findActivityData(query),
                    onOk: (function (activity) {
                        return React.createElement(FlipperAcademyLauncher$FixVersionConflict, {
                                    content: content,
                                    activity: activity,
                                    children: (function (activity) {
                                        return React.createElement(FlipperAcademyLauncher$Mutations, {
                                                    activity: activity,
                                                    children: (function (questionPasseMutation, questionFailedMutation, activityCompletedMutation, updateStateMutation) {
                                                        var component = React.createElement(Flipper_GameContent$LiteracyplanetClientSxActivity.RenderGameComponent.make, {
                                                              getTitle: (function (param) {
                                                                  return title;
                                                                }),
                                                              game: game,
                                                              content: content,
                                                              query: query
                                                            });
                                                        var match = game.activityType;
                                                        if (typeof match !== "object") {
                                                          if (match === "InstructionalVideo") {
                                                            return React.createElement(FlipperAcademyLauncher$VideoCallbacks, {
                                                                        onExit: onExit,
                                                                        children: component
                                                                      });
                                                          }
                                                          
                                                        } else if (match.TAG === "CobraActivity") {
                                                          return React.createElement(FlipperAcademyLauncher$CobraCallbacks, {
                                                                      questionPasseMutation: questionPasseMutation,
                                                                      questionFailedMutation: questionFailedMutation,
                                                                      activityCompletedMutation: activityCompletedMutation,
                                                                      activity: activity,
                                                                      children: component
                                                                    });
                                                        }
                                                        return React.createElement(FlipperAcademyLauncher$TupperwareCallbacks, {
                                                                    questionPasseMutation: questionPasseMutation,
                                                                    questionFailedMutation: questionFailedMutation,
                                                                    activityCompletedMutation: activityCompletedMutation,
                                                                    updateStateMutation: updateStateMutation,
                                                                    activity: activity,
                                                                    assessment: false,
                                                                    children: component
                                                                  });
                                                      })
                                                  });
                                      })
                                  });
                      })
                  })
            });
}

var Render = {
  make: FlipperAcademyLauncher$Render
};

function FlipperAcademyLauncher(props) {
  var onBack = props.onBack;
  var queryState = AcademyActivityQuery$LiteracyplanetClientLibsActivity.use(props.id);
  var onExit = function (param) {
    onBack();
  };
  var onGoToMissions = function (param) {
    
  };
  var onMaybeGotoCollections = function (param) {
    
  };
  return React.createElement(FlipperStore$LiteracyplanetClientSxActivity.ProviderWithMissionExit.make, {
              onExit: onExit,
              onGoToMissions: onGoToMissions,
              onMaybeGotoCollections: onMaybeGotoCollections,
              children: React.createElement(Flipper$LiteracyplanetClientSxActivity.Container.make, {
                    getActivity: getActivity,
                    getGameId: getGameId,
                    queryState: queryState,
                    onOk: (function (game, content, query) {
                        return React.createElement(FlipperAcademyLauncher$Render, {
                                    onExit: onExit,
                                    title: "Foo",
                                    game: game,
                                    content: content,
                                    query: query
                                  });
                      })
                  })
            });
}

var decode = HasuraTypes$LiteracyplanetClientFlags.decode;

var make = FlipperAcademyLauncher;

export {
  FlipperAcademyCantFindContent ,
  FlipperAcademyCantFindGameId ,
  FlipperAcademyCantFindActivity ,
  decode ,
  parseActivities ,
  getActivity ,
  getGameId ,
  findActivityData ,
  TupperwareCallbacks ,
  CobraCallbacks ,
  VideoCallbacks ,
  Mutations ,
  FixVersionConflict ,
  Render ,
  make ,
}
/* react Not a pure module */
